module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/payment-card/jcb-payment-card-0c8cbdea2c098c4c711c1450849be159.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/payment-card/jcb-payment-card.svg
// module id = v3iL
// module chunks = 24